module.exports = __webpack_public_path__ + "static/media/t8.70c10e78.jpg";